import { withStyles } from '@material-ui/core'
import React from 'react'

const Line = ({ classes, color, left }) => {
  return (
    <div
      className={classes.wrapper}
      style={{
        paddingLeft: left ? '5px' : '0px',
        paddingRight: left ? '0px' : '5px'
      }}
    >
      <div className={classes.line} style={{ backgroundColor: color }}></div>
    </div>
  )
}

const styles = () => ({
  wrapper: {},
  line: {
    width: '24px',
    height: '2px',
    backgroundColor: 'red'
  }
})

export default withStyles(styles)(Line)
